import { isCodeLongEnough } from './is-code-long-enough';
export const showType = (formData, validationConfig, types) => isCodeLongEnough(formData.code, validationConfig) && types.length > 1;
